import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useLayoutEffect, useEffect } from 'react';
import { breakpoints } from '@chegg-ui/theme';
export var PLACEHOLDER_SLOT = '...';

var generatePaginationSlots = function generatePaginationSlots(currentPage, numPages) {
  var slots = []; // we limit then number of options shown on mobile specifically for spacing reasons

  if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia("(max-width: ".concat(breakpoints.sm.max, ")")).matches) {
    if (numPages <= 2) {
      // loop because it's uncertain how many pages we have, may only be one
      for (var i = 0; i < numPages; i++) {
        slots[i] = i + 1;
      }
    } else if (currentPage === 1) {
      slots = [1, PLACEHOLDER_SLOT, numPages];
    } else if (currentPage === numPages) {
      slots = [1, PLACEHOLDER_SLOT, numPages];
    } else {
      slots = [1, currentPage, numPages];
    }
  } else {
    if (numPages <= 5) {
      // loop because it's uncertain how many pages we have, may only be one
      for (var _i = 0; _i < numPages; _i++) {
        slots[_i] = _i + 1;
      }
    } else if (currentPage < 5) {
      slots = [1, 2, 3, 4, 5, PLACEHOLDER_SLOT, numPages];
    } else if (currentPage >= numPages - 3) {
      slots = [1, PLACEHOLDER_SLOT, numPages - 4, numPages - 3, numPages - 2, numPages - 1, numPages];
    } else {
      slots = [1, PLACEHOLDER_SLOT, currentPage - 1, currentPage, currentPage + 1, PLACEHOLDER_SLOT, numPages];
    }
  }

  return slots;
};

export var usePaginationSlots = function usePaginationSlots(currentPage, numPages) {
  var _useState = useState(generatePaginationSlots(currentPage, numPages)),
      _useState2 = _slicedToArray(_useState, 2),
      paginationSlots = _useState2[0],
      setPaginationSlots = _useState2[1];

  var calculateSlots = function calculateSlots() {
    setPaginationSlots(generatePaginationSlots(currentPage, numPages));
  };

  useLayoutEffect(function () {
    calculateSlots();
  }, [currentPage, numPages]);
  useEffect(function () {
    window.addEventListener('resize', calculateSlots);
    return function () {
      return window.removeEventListener('resize', calculateSlots);
    };
  }, [currentPage]);
  return paginationSlots;
};